module.exports = __webpack_public_path__ + "img/xls.a60265cf.svg";